import { defineMessages } from 'react-intl';

export default defineMessages({
    errorBridgingOperation: {
        id: 'ml.quoteandbind.common.MLGatewayHVQLandingPage.Error in bridging operation',
        defaultMessage: 'Error in bridging operation'
    },
    unableToBridge: {
        id: 'ml.quoteandbind.common.MLGatewayHVQLandingPage.Unable to brdige xID. Please try again.',
        defaultMessage: 'Unable to bridge {quoteID}. Please try again.'
    },
    bridgingInProgress: {
        id: 'ml.quoteandbind.common.MLGatewayHVQLandingPage.Bridging in progress...',
        defaultMessage: 'Bridging in progress...'
    }
});
